import * as React from 'react';
import { addDays, startOfDay, differenceInDays } from 'date-fns';
import { Icon } from '~source/ui/components/atoms/icon/icon';
import $ from './date-navigation.scss';
import cx from '~source/utils/join-class-names';

export interface DateNavigationProps {
    date: Date;
    onChange: (newDate: Date) => void;
}

const dateFormatter = new Intl.DateTimeFormat('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
});

const formatDate = (date: Date): string => {
    const formatted = dateFormatter.format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const DateNavigation: React.FC<DateNavigationProps> = ({ date, onChange }) => {
    const today = startOfDay(new Date());
    const minDate = addDays(today, -7);
    const maxDate = addDays(today, 7);

    const isPrevDisabled = startOfDay(date) <= minDate;
    const isNextDisabled = startOfDay(date) >= maxDate;

    const dayDiff = differenceInDays(today, startOfDay(date));

    let dayNotation = '';
    switch (dayDiff) {
        case 2:
            dayNotation = 'Eergisteren:';
            break;
        case 1:
            dayNotation = 'Gisteren:';
            break;
        case 0:
            dayNotation = 'Vandaag:';
            break;
        case -1:
            dayNotation = 'Morgen:';
            break;
        case -2:
            dayNotation = 'Overmorgen:';
            break;
        default:
            dayNotation = '';
    }

    const goPrev = () => {
        if (isPrevDisabled) return;
        const newDate = addDays(date, -1);
        onChange(newDate < minDate ? minDate : newDate);
    };

    const goNext = () => {
        if (isNextDisabled) return;
        const newDate = addDays(date, 1);
        onChange(newDate > maxDate ? maxDate : newDate);
    };

    return (
        <div className={$.wrap}>
            <button
                className={cx($['nav-button'], $['nav-button-prev'])}
                onClick={goPrev}
                aria-label='Vorige dag'
                disabled={isPrevDisabled}
            >
                <Icon type='arrowRight' size={16} className={$['nav-button-icon-back']} />
            </button>
            <h1 className={$.date}>
                {dayNotation && <span className={$.notation}>{dayNotation} </span>}
                <span>{formatDate(date)}</span>
            </h1>
            <button
                className={cx($['nav-button'], $['nav-button-next'])}
                onClick={goNext}
                aria-label='Volgende dag'
                disabled={isNextDisabled}
            >
                <Icon type='arrowRight' size={16} />
            </button>
        </div>
    );
};
